import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import Chip from '@mui/material/Chip';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useNavigate } from 'react-router-dom';

const columns = [
    {
        field: 'link',
        headerName: 'Link',
        width: 50,
        renderCell: (params) => (
            <i className="bi bi-info-circle"></i>
        ),
    },
    { field: 'productId', headerName: 'ID', width: 150 },
    { field: 'productName', headerName: 'Product Name', width: 150 },
    { field: 'manufacturer', headerName: 'Manufacturer', width: 150 },
    { field: 'model', headerName: 'Model', width: 150 },
    { field: 'price', headerName: 'Price', width: 150 },
    { field: 'quantityInStock', headerName: 'Quantity In Stock', width: 150 }, 
    
];

export default function ProductTable() {
    const { GetPackageByPartner, products } = useServiceContext();
    const userType = localStorage.getItem('userType');
    const navigate = useNavigate();

    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        navigate(`/viewproduct/${params.id}/false`, { state: { branch: params.row } });
    };

    const handleAddPackage = () => {
        navigate('/addproduct');
    };
   

    const CustomToolbar = (props) => (
        <GridToolbarContainer>
            {(userType === 'PARTNER') && <EditToolbar {...props} />}
            <GridToolbar />
        </GridToolbarContainer>
    );
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            handleAddPackage();
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    Product
                </Button>
            </GridToolbarContainer>
        );
    }

    return (
        <main id="main" className="main">
            <div className="pagetitle">
            <h1>Products</h1>
                <nav>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li class="breadcrumb-item"><a href="/products">Products</a></li>
                        
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">

                                <h5 className="card-title"></h5>
                                {/* Tabs */}
                                <Box sx={{ width: '100%' }}>
                                    <AppBar position="static" color="default">
                                        {/* AppBar content can go here */}
                                    </AppBar>
                                  
                                </Box>

                                <div style={{ height: '100%', width: '100%' }}>
                                    <DataGrid
                                    getRowId={(row) => row.productId}
                                        rows={products}
                                        
                                        columns={columns}
                                        slots={{ toolbar: CustomToolbar }}
                                        onRowClick={handleRowClick} // Add this line to handle row clicks
                                        components={{ Toolbar: GridToolbar }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>
        </main>
    );
}
